import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { ProjectInfo } from './projectinfo';
import { Observable } from 'rxjs/Rx';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import * as globals from '../globals';

@Injectable()
export class ProjectsService {
  private projectsUrl = globals.APIURL + '/projects';
  private processUrl = this.projectsUrl + '/process';
  private processStatusUrl = this.processUrl + '/status';
  private translateUrl = this.projectsUrl + '/translate';
  private translateStatusUrl = this.translateUrl + '/status';
  private shapesearchUrl = this.projectsUrl + '/shapesearch';
  private shareUrl = globals.APIURL + '/sharefile';
  private S3CredsUrl = this.projectsUrl + '/s3/';
  private quotes3URL = globals.APIURL + '/admin/quote/s3/';

  private projectobservable: Observable<any>;
  private projectData: string;
  private forceupdatebool = false;
  private currentSearchedTerm: string;
  private lastUpdatedTime: any;

  constructor(private http: Http, public authHttp: AuthHttp) { }

  getProjects(forceUpdateCache: boolean, currentPage: number, itemsPerPage: number, type: number, searchTerms: any) {
    let CurrentTime = new Date();
    if (this.lastUpdatedTime && !forceUpdateCache) {
      forceUpdateCache = this.cacheTimeExceeded(CurrentTime);
    }
    if (this.projectData && !forceUpdateCache) {
      // if `data` is available just return it as `Observable`
      return Observable.of(this.projectData);
    } else if (this.projectobservable && !forceUpdateCache) {
      // if `this.observable` is set then the request is in progress
      // return the `Observable` for the ongoing request
      return this.projectobservable;
    } else {
      let body = JSON.stringify({ currentPage: currentPage, itemsPerPage: itemsPerPage,  searchterms: searchTerms, type: type });
      let headers = new Headers({
        'Content-Type': 'application/json'
      });

      let options = new RequestOptions({ body: body, headers: headers });
      console.log('Projects: OPTIONS =>', options);
      console.log('URL:', this.projectsUrl);
      // create the request, store the `Observable` for subsequent subscribers
      // this.projectobservable = this.authHttp.get(this.projectsUrl+'/page/'+ pagenum, options)
      this.projectobservable = this.authHttp.post(this.projectsUrl + '/page', body, options)
        .map(response => {
          // when the cached data is available we don't need the `Observable` reference anymore
          this.projectobservable = null;

          if (response.status == 400) {
            return 'FAILURE';
          } else if (response.status == 200) {
            this.projectData = response.json();
            this.lastUpdatedTime = new Date();
            return this.projectData;
          }
          // make it shared so more than one subscriber can get the result
        })
        .catch(this.handleError)
        .share();
      return this.projectobservable;
    }
  }

  cacheTimeExceeded(CurrentTime: any) {
    // Customise date2 for your required future time

    let difference = (CurrentTime - this.lastUpdatedTime) / 1000;
    let diff = Math.abs(Math.floor(difference));

    let days = Math.floor(diff / (24 * 60 * 60));
    let secondsLeft = diff - days * 24 * 60 * 60;

    let hrs = Math.floor(secondsLeft / (60 * 60));
    let midSecondsLeft = secondsLeft - hrs * 60 * 60;

    let min = Math.floor(midSecondsLeft / (60));
    let leftSec = midSecondsLeft - min * 60;

    console.log('You have ' + days + ' days ' + hrs + ' hours ' + min + ' minutes and ' + leftSec + ' seconds before last updated time.');
    if (min > globals.update_ProjectDataCache_timeDuration) {
      return true;
    } else {
      return false;
    }
  }


  startProcessingUpload(projectid: string, tenantid: string, filename: string, planid: string): Observable<string> {
    console.log('startProcessing service method called');

    let body = JSON.stringify({ projectid: projectid, tenantid: tenantid, filename: filename, planid: planid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: body, headers: headers });
    console.log('URL =>', this.processUrl);
    console.log('BODY =>', body);
    console.log('OPTIONS =>', options);

    return this.authHttp.post(this.processUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  processingUploadCheck(): Observable<string> {
    console.log('processingUploadCheck service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.processStatusUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  startTranslation(tenantid: string, projectid: string, filename: string, type: string): Observable<string> {
    console.log('startTranslation service method called');

    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid, filename: filename, type: type });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  translationCheck(tenantid: string, projectid: string): Observable<string> {
    console.log('translationCheck service called');
    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  downloadPDF(url): any {

    return this.http.get(url, { responseType: ResponseContentType.Blob }).map(
      (res) => {
          return new Blob([res.blob()], { type: 'application/pdf' })
      });
  }

  updateProject(id: number, updateProjectdetails: any): Observable<string> {
    console.log('uploadProject service method called');
    console.log('Project name  : ' + updateProjectdetails.projectname);
    // console.log('File array count:', file.length);

    let body = JSON.stringify({ project: updateProjectdetails });

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });

    return this.authHttp.put(this.projectsUrl + '/' + id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  shapeSearch(vizseekguid: string): Observable<string> {
    console.log('startTranslation service method called');

    let body = JSON.stringify({ vizseekguid: vizseekguid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.shapesearchUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/projects/projects.service.ts